'use client';

import { type MouseEventHandler, forwardRef, useCallback, useContext } from 'react';

import { Slot } from '../slot';
import { PopoverRootContext } from './context/popover-root.context';
import type { PopoverClosePropsInterface } from './types/popover-close.types';

/**
 * @since 10.0.0
 */
export const PopoverClose = forwardRef<HTMLButtonElement, PopoverClosePropsInterface>(
  (props: PopoverClosePropsInterface, forwardedRef) => {
    const { children, onClick, ...rest } = props;
    const { popover } = useContext(PopoverRootContext);

    const onClickHandler = useCallback<MouseEventHandler<HTMLButtonElement>>(
      (event) => {
        popover.onClickClose(event);
        onClick?.(event);
      },
      [popover, onClick],
    );

    return (
      <Slot
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Popover.Close"
        {...rest}
        onClick={onClickHandler}
      >
        {children}
      </Slot>
    );
  },
);

PopoverClose.displayName = 'Popover.Close';
